import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Clock, MapPin, Award, TrendingUp, Milk } from 'lucide-react';
import MyButton from '../../../components/common/Button/MyButton';
import '../../../assets/styles/customer/layout/WhyDistributorsSection.css';

const WhyDistributorsSection = () => {
  const features = [
    {
      id: 1,
      icon: <Clock size={28} strokeWidth={2} />,
      title: 'Save 2+ Hours Daily',
      description: 'No more manual record-keeping or end-of-month calculations.',
      color: '#3e96e7'
    },
    {
      id: 2,
      icon: <MapPin size={28} strokeWidth={2} />,
      title: 'Optimized Routes',
      description: 'Smart route planning to serve more customers efficiently.',
      color: '#3e96e7'
    },
    {
      id: 3,
      icon: <Award size={28} strokeWidth={2} />,
      title: 'Build Trust',
      description: 'Transparent records that customers can verify anytime.',
      color: '#3e96e7'
    },
    {
      id: 4,
      icon: <TrendingUp size={28} strokeWidth={2} />,
      title: 'Grow Your Business',
      description: 'Professional tools that help you expand your customer base.',
      color: '#3e96e7'
    }
  ];

  return (
    <section className="why-distributors-section">
      
      {/* Floating Achievement Icons */}
      <div className="why-dist-floating">
        <div className="float-achievement achievement-1">📊</div>
        <div className="float-achievement achievement-2">✅</div>
        <div className="float-achievement achievement-3">🚀</div>
        <div className="float-achievement achievement-4">⭐</div>
        <div className="float-achievement achievement-5">📱</div>
      </div>

      {/* Decorative Circles */}
      <div className="why-dist-circles">
        <div className="why-circle circle-1"></div>
        <div className="why-circle circle-2"></div>
        <div className="why-circle circle-3"></div>
      </div>

      {/* Animated Dots Pattern */}
      <div className="why-dist-pattern">
        <div className="pattern-dot"></div>
        <div className="pattern-dot"></div>
        <div className="pattern-dot"></div>
        <div className="pattern-dot"></div>
        <div className="pattern-dot"></div>
        <div className="pattern-dot"></div>
      </div>

      <Container>
        <Row className="align-items-center g-4">
          
          {/* Left Side - Features List */}
          <Col lg={6} md={12}>
            <div className="why-dist-content">
              
              <h2 className="why-dist-title">
                Why Distributors <span className="why-dist-highlight">Love Us</span>
              </h2>

              <div className="features-list">
                {features.map((feature, index) => (
                  <div 
                    className="feature-item" 
                    key={feature.id}
                    style={{ animationDelay: `${index * 0.15}s` }}
                  >
                    <div 
                      className="feature-icon-box"
                      style={{ backgroundColor: `${feature.color}15` }}
                    >
                      <div 
                        className="feature-icon"
                        style={{ color: feature.color }}
                      >
                        {feature.icon}
                      </div>
                    </div>
                    
                    <div className="feature-text">
                      <h4 className="feature-title">{feature.title}</h4>
                      <p className="feature-description">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </Col>

          {/* Right Side - CTA Card */}
          <Col lg={6} md={12}>
            <div className="why-dist-cta-card">
              
              {/* Rotating Glow Effect */}
              <div className="cta-glow"></div>

              {/* Milk Icon */}
              <div className="cta-milk-icon">
                <Milk size={70} strokeWidth={1.5} />
              </div>

              <h3 className="cta-heading">
                Ready to Transform Your Business?
              </h3>

              <p className="cta-text">
                Join hundreds of distributors who have already modernized their 
                operations with MilkFlow.
              </p>

              <MyButton variant="light" className="cta-start-btn">
                Get Started Free
              </MyButton>

            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default WhyDistributorsSection;